import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "En-Taro Arc Specialized Steel Works | Steel Fabrication Johannesburg",
  description = "En-Taro Arc - Professional steel fabrication in Johannesburg, Gauteng. Specializing in car ports, gates, railings, braais, and custom metalwork.",
  path = "/"
}) => {
  // Use window.location.origin to dynamically construct canonical URL
  const canonical = typeof window !== 'undefined' ? `${window.location.origin}${path}` : path;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
